import TakeawayPaymentSummary from '../../components/TakeawayPaymentSummary'
import { injectIntl } from 'react-intl'
import { bindActionCreators } from 'redux'
import { connect } from 'react-redux'
import { withRouter } from 'react-router'
import * as basketActions from '../../actions/components/basket'
import * as soldOutActions from '../../actions/components/soldOut'
import * as formActions from '../../actions/components/form'
import * as promocodesActions from '../../actions/components/promocodes'
import * as campaingnActions from '../../actions/components/campaign'

import { injectStripe } from 'react-stripe-elements'

const mapStateToProps = (state) => {
  return {
    user: state.user,
    merchant: state.merchant,
    basket: state.basket,
    orders: state.orders,
    soldOut: state.soldOut,
    campaign: state.campaign,
  }
}

const mapDispatchToProps = (dispatch) => {
  return {
    ...bindActionCreators(basketActions, dispatch),
    ...bindActionCreators(soldOutActions, dispatch),
    ...bindActionCreators(formActions, dispatch),
    ...bindActionCreators(promocodesActions, dispatch),
    ...bindActionCreators(campaingnActions, dispatch),
  }
}

export default withRouter(connect(
  mapStateToProps,
  mapDispatchToProps,
)(injectStripe(injectIntl(TakeawayPaymentSummary))))



// WEBPACK FOOTER //
// ./src/containers/components/TakeawayPaymentSummary.js